import {
  ModuleWithProviders,
  NgModule,
  Optional,
  SkipSelf,
} from '@angular/core'
import { Configuration } from './configuration'
import { HttpClient } from '@angular/common/http'

import { AppsService } from './api/apps.service'
import { CommonModule } from '@angular/common'

@NgModule({
  imports: [CommonModule],
  declarations: [],
  exports: [],
  providers: [AppsService],
})
export class AppPortalServicesApiModule {
  static forRoot(
    configurationFactory: () => Configuration
  ): ModuleWithProviders<AppPortalServicesApiModule> {
    return {
      ngModule: AppPortalServicesApiModule,
      providers: [{ provide: Configuration, useFactory: configurationFactory }],
    }
  }

  constructor(
    @Optional() @SkipSelf() parentModule: AppPortalServicesApiModule,
    @Optional() http: HttpClient
  ) {
    if (parentModule) {
      throw new Error(
        'ApiModule is already loaded. Import in your base AppModule only.'
      )
    }
    if (!http) {
      throw new Error(
        'You need to import the HttpClientModule in your AppModule! \n' +
          'See also https://github.com/angular/angular/issues/20575'
      )
    }
  }
}
